import { render } from "./FBLoader.vue?vue&type=template&id=1c27612f&scoped=true"
const script = {}

import "./FBLoader.vue?vue&type=style&index=0&id=1c27612f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c27612f"]])

export default __exports__